import type { AuditTranslations } from "../interfaces/audit";

export const auditTranslations: AuditTranslations = {
  page_title: "Auditoria",
  page_subtitle: "Consulte e filtre os registros de auditoria por fluxo, ação e datas.",
  button_refresh: "Atualizar",
  page_loading: "Carregando registros de auditoria...",

  filters_heading: "Filtros",
  filters_label_flujo: "Fluxo",
  filters_label_accion: "Ação",
  filters_label_date_start: "Data de início",
  filters_label_date_end: "Data de fim",
  filters_placeholder_flujo: "Selecionar fluxo",
  filters_placeholder_accion: "Selecionar ação",
  filters_label_search: "Buscar por referência",
  filters_placeholder_search: "Buscar em registros de auditoria...",
  filters_label_client: "Subclientes",
  filters_placeholder_client: "Buscar subclientes…",
  filters_label_organization: "Clientes",
  filters_placeholder_organization: "Buscar clientes…",
  filters_dropdown_empty: "Sem resultados",
  filters_hint: 'O filtro será aplicado na API ao clicar em "Aplicar Filtros"',
  filters_button_apply: "Aplicar Filtros",
  filters_button_clear: "Limpar Filtros",
  filters_label_amount_min: "Valor mínimo",
  filters_label_amount_max: "Valor máximo",
  filters_placeholder_amount_min: "ex. 0",
  filters_placeholder_amount_max: "ex. 1000000",

  filter_flujo_note: "Nota",
  filter_flujo_payment_confirmation: "Confirmação de pagamento",
  filter_flujo_payment: "Pagamento",
  filter_flujo_shipping_quote: "Cotação de envio",
  filter_flujo_public_account: "Conta pública",

  flujo_pago: "Pagamento",
  flujo_confirmacion: "Confirmação",
  flujo_nota: "Notas",

  accion_cambio_estado: "Mudança de estado",
  accion_actualizacion_datos: "Atualização de dados",
  accion_creacion: "Criação",
  accion_eliminacion: "Eliminação",

  table_showing_one: "Mostrando 1 registro nesta página (Total: {{total}})",
  table_showing_many: "Mostrando {{count}} registros nesta página (Total: {{total}})",
  table_show_label: "Mostrar:",
  table_th_date: "Data",
  table_th_reference_code: "Código de referência",
  table_th_flujo: "Fluxo",
  table_th_client: "Cliente",
  table_th_currency: "Moeda",
  table_th_amount: "Valor",
  table_th_accion: "Ação",
  table_th_estado: "Estado",
  table_estado_filed: "COMPLETED",
  table_th_created_by: "Criado por",
  table_th_taken_by: "Tomado por",
  table_th_archivos: "Arquivos",
  table_th_actions: "Ações",
  table_empty: "Não há registros para exibir.",
  table_button_view_history: "Ver histórico",
  table_tooltip_view_archivos: "Ver arquivos",

  pagination_records: "Registros de {{from}} a {{to}} de {{total}}",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primeira página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Próxima página",
  pagination_last_page: "Última página",

  modal_title: "Histórico da entidade",
  modal_close_aria: "Fechar",
  modal_loading: "Carregando histórico…",
  modal_error_load: "Não foi possível carregar o histórico.",
  modal_empty: "Não há registros no histórico.",
  modal_section_title: "Histórico de alterações",
  modal_duration: "Duração",
  modal_initial_status: "Estado inicial",
  modal_current_status: "Estado atual",
  modal_previous_status: "Estado anterior",
  modal_close_button: "Fechar",

  modal_action_create: "Criação",
  modal_action_update: "Atualização de dados",
  modal_action_delete: "Eliminação",
  modal_action_status_change: "Mudança de estado",
  modal_action_restore: "Restauração",
  modal_action_view: "Visualização",
  modal_action_take: "Tomado",
  modal_action_release: "Liberado",

  modal_status_pending: "Pendente",
  modal_status_in_progress: "Em progresso",
  modal_status_paid: "Pago",
  modal_status_confirmed: "Confirmado",
  modal_status_cancelled: "Cancelado",
  modal_status_archived: "Arquivado",
  modal_status_filed: "Arquivado (filed)",

  modal_archivos_no_comprobantes_note: "Visualização de comprovantes em breve",
  modal_archivos_no_comprobantes_payment_creation: "Por enquanto não há comprovantes para visualizar.",
  modal_archivos_no_comprobantes_default: "Não há comprovantes para exibir",
  modal_archivos_deletion_note_label: "Motivo do cancelamento",
  modal_archivos_confirmation_source_label: "Ingresso de banco",
  modal_archivos_payment_source_label: "Saída de Banco",

  tab_audit_general: "Solicitações de confirmações de pagamentos",
  tab_payments: "Solicitações de pagamentos",

  payments_loading: "Carregando registros de pagamentos...",
  payments_filters_heading: "Filtros de Solicitações de Pagamentos",
  payments_filters_label_org_name: "Nome do cliente",
  payments_filters_placeholder_org_name: "ex. Empresa ABC",
  payments_filters_label_client_name: "Nome do subcliente",
  payments_filters_placeholder_client_name: "ex. João Silva",
  payments_filters_hint: 'Os filtros serão aplicados na API ao clicar em "Aplicar Filtros"',
  payments_table_empty: "Não há registros de pagamentos para exibir.",
  payments_table_th_client: "Cliente",
  payments_table_th_subclient: "Subcliente",
  payments_table_showing_one: "Mostrando 1 registro nesta página (Total: {{total}})",
  payments_table_showing_many: "Mostrando {{count}} registros nesta página (Total: {{total}})",
  payments_filters_type_to_search: "Digite para buscar...",
  payments_filters_label_payment_source: "Saída de Banco",
  payments_filters_placeholder_payment_source: "Selecionar saída de banco",
  filters_label_confirmation_source: "Ingresso de Banco",
  filters_placeholder_confirmation_source: "Selecionar ingresso de banco",

  tab_verification: "Solicitações de verificação",
  verification_filters_heading: "Buscar solicitações de verificação",
  verification_label_org_email: "Email do cliente",
  verification_placeholder_org_email: "ex. cliente@empresa.com",
  verification_label_client_email: "Email do subcliente",
  verification_placeholder_client_email: "ex. subcliente@email.com",
  verification_filters_hint: "Insira um email para realizar a busca. Apenas um campo pode ser usado por vez",
  verification_loading: "Buscando solicitações de verificação...",
  verification_results_title: "URLs de verificação encontradas",
  verification_type_organization: "Cliente",
  verification_type_client: "Subcliente",
  verification_empty: "Nenhuma URL de verificação encontrada para os critérios inseridos.",
  verification_btn_copy: "Copiar",
  verification_status_active: "Ativo",
  verification_status_used: "Usado",
  verification_status_expired: "Expirado",
  verification_error_org_not_found: "Nenhum cliente encontrado com o email inserido",
  verification_error_client_not_found: "Nenhum subcliente encontrado com o email inserido",
};
